import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AlertService } from '../../../../projects/vendors/src/lib/services/alert.service';

@Injectable()
export class GlobalErrorInterceptor implements HttpInterceptor {

  constructor(
    private alertService: AlertService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (this.shouldSkipErrorHandling(req.url)) {
          return throwError(() => error);
        }

        console.error('HTTP Error:', error);

        switch (error.status) {
          case 401:
            this.alertService.showError('Unauthorized: Please log in again.');
            break;

          case 403:
            this.alertService.showError('Access Denied: You do not have permission to perform this action. Please contact your administrator.');
            break;

          case 404:
            this.alertService.showError('The requested resource was not found.');
            break;

          case 500:
            this.alertService.showError('Internal server error. Please try again later.');
            break;

          case 0:
            this.alertService.showError('Network error. Please check your connection.');
            break;

          default:
            if (error.status >= 400 && error.status < 500) {
              const message = error.error?.message || error.error?.title || 'Client error occurred.';
              this.alertService.showError(message);
            } else if (error.status >= 500) {
              this.alertService.showError('Server error occurred. Please try again later.');
            }
            break;
        }

        return throwError(() => error);
      })
    );
  }

  private shouldSkipErrorHandling(url: string): boolean {
    const skipUrls = [
      '/qr-session',
      '/qr/session',
      '/qr/approvals',
    ];
    return skipUrls.some((skipUrl) => url.includes(skipUrl));
  }
}
